import { createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
import "core-js/modules/esnext.iterator.map.js";
import { createTableActionItem, createTableColumn, createTableColumnSlot, createTableHeaderButton } from "@/component-create/utils/create-table-column";
import { Table } from "@/component-create/Table";
import { MESSAGE_RECIPIENT, MESSAGE_STATUS, MESSAGE_TYPE } from "@/constant/system/code";
import { ElLink, ElTag, ElSwitch } from "element-plus";
import 'element-plus/es/components/link/style/css'
import 'element-plus/es/components/tag/style/css'
import 'element-plus/es/components/switch/style/css'

import { View } from '@element-plus/icons-vue';
import { MESG_PAGE_URL, remove, updateStatus } from "@/api/system/message";
import { deleteBox, toast } from "@/utils/message";
const statusUpdating = ref(false);
let tb;
let searchData;
export const createMessageTable = (el, row, header, sdata) => {
  const _table = new Table(el, column(row), headerButtons(header), {
    border: true
  }, MESG_PAGE_URL);
  tb = _table;
  searchData = sdata;
  return _table;
};
export const column = rowFn => {
  const col = [{
    type: 'selection'
  }, {
    label: '序号',
    type: 'index',
    width: '60'
  }, createTableColumn('主题', 'subject'), createTableColumnSlot('内容', row => {
    return _createVNode(ElLink, {
      "onClick": () => {
        rowFn.rowShow(row, []);
      },
      "type": "primary",
      "underline": false,
      "icon": View
    }, {
      default: () => [_createVNode("span", {
        "style": {
          paddingLeft: '8px'
        }
      }, [_createTextVNode("\u67E5\u770B\u5185\u5BB9")])]
    });
  }, {
    width: '120',
    align: 'center'
  }), createTableColumn('备注', 'remark', undefined, undefined, {
    showOverflowTooltip: true
  }), createTableColumnSlot('类型', row => {
    if (row.type === MESSAGE_TYPE.NOTICE.CODE) {
      return h(_createVNode(ElTag, {
        "type": "success",
        "size": "small"
      }, {
        default: () => [MESSAGE_TYPE.NOTICE.NAME]
      }));
    } else if (row.type === MESSAGE_TYPE.MESSAGE.CODE) {
      return h(_createVNode(ElTag, {
        "size": "small"
      }, {
        default: () => [MESSAGE_TYPE.MESSAGE.NAME]
      }));
    } else {
      return h(_createVNode("div", null, null));
    }
  }, {
    align: 'center',
    width: '100'
  }), createTableColumnSlot('收件人', row => {
    if (row.recipient === MESSAGE_RECIPIENT.ALL.CODE) {
      return h(_createVNode(ElTag, {
        "type": "success",
        "size": "small"
      }, {
        default: () => [MESSAGE_RECIPIENT.ALL.NAME]
      }));
    } else if (row.recipient === MESSAGE_RECIPIENT.DEPT.CODE) {
      return h(_createVNode(ElTag, {
        "size": "small"
      }, {
        default: () => [MESSAGE_RECIPIENT.DEPT.NAME]
      }));
    } else if (row.recipient === MESSAGE_RECIPIENT.USER.CODE) {
      return h(_createVNode(ElTag, {
        "type": "info",
        "size": "small"
      }, {
        default: () => [MESSAGE_RECIPIENT.USER.NAME]
      }));
    } else {
      return h(_createVNode("div", null, null));
    }
  }, {
    width: '120',
    align: 'center'
  }), createTableColumn('作者', 'author', '120'), createTableColumnSlot('是否发布', row => h(_createVNode(ElSwitch, {
    "modelValue": row.status,
    "onUpdate:modelValue": $event => row.status = $event,
    "active-value": MESSAGE_STATUS.PUBLISHED.CODE,
    "inactive-value": MESSAGE_STATUS.DRAFTED.CODE,
    "disabled": statusUpdating.value,
    "onChange": () => {
      handleUpdateStatus(row);
    }
  }, null)), {
    width: '100',
    align: 'center'
  }), createTableColumn('发布时间', 'pubDate', '160', 'center', {
    sortable: true
  }), createTableColumn('创建时间', 'createdAt', '160', 'center', {
    sortable: true
  }), createTableColumn('操作', undefined, '200', 'center', {
    controller: [createTableActionItem('编辑', 'Edit', rowFn.rowEdit), createTableActionItem('删除', 'Delete', row => {
      deleteBox().then(() => {
        remove([row.id]).then(() => {
          toast.success('删除成功');
          tb.load(searchData.value);
        });
      });
    })]
  })];
  return col;
};
/**
 * 表格头部按钮
 */
function headerButtons(table) {
  return [createTableHeaderButton('新增', 'primary', 'Plus', table.addFn), createTableHeaderButton('编辑', 'primary', 'Edit', table.editFn), createTableHeaderButton('删除', 'primary', 'Delete', rows => {
    if (rows.length > 0) {
      deleteBox().then(() => {
        remove(rows.map(i => i.id)).then(() => {
          toast.success('删除成功');
          tb.load(searchData.value);
        });
      });
    } else {
      toast.warn('请至少选择一条数据');
    }
  })];
}
function handleUpdateStatus(data) {
  statusUpdating.value = true;
  updateStatus(data).then(() => {
    toast.success('状态更新成功');
  }).catch(() => {
    if (data.status === MESSAGE_STATUS.DRAFTED.CODE) {
      data.status = MESSAGE_STATUS.PUBLISHED.CODE;
    } else {
      data.status = MESSAGE_STATUS.DRAFTED.CODE;
    }
  }).finally(() => {
    statusUpdating.value = false;
  });
}